import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { fmtErr, API } from "../../lib/api";
import { PageHeader, EmptyState } from "../../components/bits";
import { Library, FileDown, FileText, FileType } from "lucide-react";

export default function Resources() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/portal/resources").then((r) => setItems(r.data)).catch((e) => toast.error(fmtErr(e)));
  }, []);

  if (!items) return <div className="text-center text-mutext py-20 font-head">جارٍ التحميل …</div>;

  return (
    <div data-testid="resources-page">
      <PageHeader title="مكتبة الموارد والنماذج" sub="محاضر وشهادات وأدلة جاهزة بصيغتي PDF وWord" />
      {items.length === 0 ? (
        <EmptyState testid="resources-empty" text="المكتبة قيد التعبئة من الإدارة العامة" />
      ) : (
        <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-4">
          {items.map((r) => (
            <div key={r.id} data-testid={`resource-card-${r.id.slice(0, 8)}`}
              className="bg-surface rounded-2xl border border-brd shadow-md p-5 flex items-start gap-4">
              <div className="w-11 h-11 rounded-xl bg-turq-100 dark:bg-surface2 flex items-center justify-center shrink-0">
                {r.format === "Word" ? <FileType className="w-5 h-5 text-turq-900 dark:text-turq-300" /> : <FileText className="w-5 h-5 text-turq-900 dark:text-turq-300" />}
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-bold text-sm">{r.title}</div>
                <div className="text-[11px] text-mutext mt-1 flex items-center gap-2">
                  <Library className="w-3 h-3" /> {r.category}
                  <span className="bg-beige-600 dark:bg-surface2 rounded-full px-2 py-0.5 text-[10px] font-bold">{r.format}</span>
                </div>
                <a data-testid={`resource-download-${r.id.slice(0, 8)}`}
                  href={r.storage_path ? `${API}/portal/resources/file/${r.id}` : r.url} target="_blank" rel="noreferrer"
                  className="mt-3 inline-flex items-center gap-1.5 text-[11.5px] font-bold text-coral-600 hover:text-coral-900">
                  <FileDown className="w-3.5 h-3.5" /> تحميل النموذج
                </a>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
